import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {YandexService} from 'services/yandexSDK'
import type {LangType, MessagesType} from 'src/lib/translates/types'
import {DEFAULT_LANG} from 'src/lib/translates/consts'
import {onReject} from '../handler'
import {TranslatesState} from './entities'
import {getTranslatesThunk} from './thunk'

const initialState: TranslatesState = {
  messages: {},
  lang: YandexService?.getLang() || DEFAULT_LANG,
}

const translatesSlice = createSlice({
  name: 'translates',
  initialState,
  reducers: {
    setTranslates: (state, action: PayloadAction<MessagesType>) => {
      state.messages = action.payload;
      return state;
    },
    setLanguage: (state, action: PayloadAction<LangType>) => {
      state.lang = action.payload;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTranslatesThunk.fulfilled, (state) => {
      return state;
    });
    builder.addCase(getTranslatesThunk.rejected, (state, action) => {
      onReject(action.payload);
    });
  },
})

export const {
  setTranslates,
  setLanguage,
} = translatesSlice.actions;

export default translatesSlice.reducer
